export default function(ngModule) {
    ngModule.factory('Export', function(BaseClass,$q, $http) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function Export(attributes) {
            _.assign(this,attributes);
        }
        Export.modelName = 'Export';


        BaseClass.apply(Export);

        Export.validates({
            name: {
                required: true,
                format: {
                    regex: {
                        regex: /^[^+#\/]+$/,
                        message: 'Invalid character: [+, #, /] characters are not allowed.'
                    }
                }
            },
            type: {
                required: true,
                inclusion: {
                    in: [
                        'orders',
                        'order_tickets',
                        'orders_and_order_tickets',
                        'orders_and_order_tickets_and_order_products',
                        'direct_mail',
                        'order_tickets_scanned',
                        'orders_location',
                        'order_products_optional'
                    ]
                }
            },
            filetypes: {
                minSelected: {
                    validator: function(value) {
                        if(!value)
                            return false;
                        return value.length > 0;
                    },
                    message: 'select at least 1 filetype'
                }
            },
            events: {
                minSelected: {
                    validator: function(value) {
                        if(!value)
                            return false;
                        return value.length > 0;
                    },
                    message: 'select at least 1 event'
                }
            }
        });

        Export.configureApi('/export/:guid', {
            queryAdmin: '/export/:status/:company',
            reinstate: '/export/:guid/reinstate'
        });
        Export.belongsTo('Company', 'company_id', 'guid', '/company/^guid');
        Export.prototype.toString = function() { return this.name; };

        return Export;
    });
}
